import "./Banner.scss";
import Bannervid from "../../../assets/Banner_slide/tgm1.mp4";
import React, { useEffect, useState } from 'react';

const Banner = () => {
    const [showBanner, setShowBanner] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
  useEffect(() => {
      // Start fade out after 3 seconds
      const timer1 = setTimeout(() => {setFadeOut(true);}, 3000);
    // Hide banner and show video after fade out completes
      const timer2 = setTimeout(() => {setShowBanner(false);}, 1000); // 1s for fade transition
    return () => {clearTimeout(timer1); clearTimeout(timer2);};
  }, []);

return (
  <div>
    <div className="App">
      {showBanner ? (<div className={`banner ${fadeOut ? 'fade-out' : 'fade-in'}`}>
      </div>) : (
      <div className="video-section fade-in">
          <video width="100%" autoPlay loop muted >
            <source src={Bannervid} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
    </div>
      )}
    </div>
  </div>
  );
}
export default Banner;